module.exports = __webpack_public_path__ + "assets/icons/ic_view_module-aaff.svg";